exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TVXSsOTYkt9bu7eOhxO7y{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] ._11sijztApdZBYbraNfTRRm,html[dir] .TVXSsOTYkt9bu7eOhxO7y{margin-top:20px}html[dir=ltr] ._11sijztApdZBYbraNfTRRm{margin-right:16px}html[dir=rtl] ._11sijztApdZBYbraNfTRRm{margin-left:16px}html[dir] ._2FRHOx6RFDE92hMUDNr37g{margin-top:20px}", ""]);

// exports
exports.locals = {
	"sharePbpSection": "TVXSsOTYkt9bu7eOhxO7y",
	"copyButton": "_11sijztApdZBYbraNfTRRm",
	"shareButton": "_2FRHOx6RFDE92hMUDNr37g"
};